<script lang="ts" setup>
import { computed } from 'vue'
import { getAppIcon } from '@/Support/Common/Interfaces/appIcons'
import { ModelName } from '@/Support/Global/Interfaces/ModelName'

interface Props {
  icon?: string | ModelName
  hero?: boolean
  heroBig?: boolean
  solid?: boolean
  mini?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  icon: 'edit',
})

const iconItem = computed(() => getAppIcon(props.icon))

const icon = computed(() => {
  switch (true) {
    case props.heroBig:
      return iconItem.value.heroBig

    case props.hero:
      return iconItem.value.hero

    case props.solid:
      return iconItem.value.solid

    case props.mini:
      return iconItem.value.mini

    default:
      return iconItem.value.component
  }
})
</script>

<template>
  <component :is="icon" :name="iconItem.name" aria-hidden="true" />
</template>
